module.exports = __webpack_public_path__ + "static/curiosity_pattern-2500dde104b472ebb0d0d5d3ca2ecd28.svg";